function convertToCSV(table) {
    var csv = [];
    var rows = table.querySelectorAll("tr");

    for (var i = 0; i < rows.length; i++) {
        var row = [];
        var cols = rows[i].querySelectorAll("td, th");

        for (var j = 0; j < cols.length; j++) {
            var cellText = cols[j].innerText.replace(/\n/g, ' ').trim();
            row.push('"' + cellText + '"');
        }

        csv.push(row.join(";")); // Muda de "," para ";"
    }

    return csv.join("\n");
}

export function exportToExcel(selector) {
    var table = document.querySelector(selector);
    if (!table) {
        console.error("Tabela não encontrada!");
        return;
    }

    var csvData = convertToCSV(table);
    
    // Adiciona o BOM para corrigir a codificação no Excel
    var bom = "\uFEFF";
    var blob = new Blob([bom + csvData], {
        type: "text/csv;charset=utf-8;"
    });

    var link = document.createElement("a");
    if (link.download !== undefined) {
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "Tabela.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}